import * as React from 'react';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch, { SwitchProps } from '@mui/material/Switch';
import Box from '@mui/material/Box';

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({

}));

export default function IosSwitch() {
  const [checked, setChecked] = React.useState(true);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  return (
    <Box className={`switch-container ${checked ? 'active' : 'inactive'}`}>
      <FormControlLabel
        control={<IOSSwitch checked={checked} onChange={handleChange} />}
        label={checked ? 'Activate' : 'Inactive'}
      />
    </Box>
  );
}
